import apiService from './apiService'

export const requestBroadcastNotification = (notificationPayload) => {
  return apiService.post(URIS.notification, notificationPayload)
}

export const requestBroadcastUserNotification = (notificationPayload) => {
  return apiService.post(URIS.user_notification, notificationPayload)
}

export const getProductListByProductIds = (ids) => {
  let queryParams = { ids: ids?.join(',') }
  return apiService.get(URIS.products, { params: queryParams })
}

export const deleteScheduledNotification = (id) => {
  return apiService.delete(URIS_D('scheduled', id))
}

export const updateScheduledNotification = (id, payload) => {
  return apiService.put(URIS_D('scheduled', id), payload)
}

export const postScheduleNotification = (payload) => {
  return apiService.post(URIS.scheduled_notification, payload);
}

export const getRecieverCount = (payload) => {
  return apiService.post(URIS.receiver_count, payload);
}

export const getNotificationReport = (page = 1, dateFrom, dateTo, type) => {
  let queryParams = {
    page: page,
   ...(dateFrom && {start_date: dateFrom}),
   ...(dateTo && {end_date: dateTo}),
    type
  }
  return apiService.get(URIS.notification_report, {params: queryParams});
}

export const getBulkNotification = (type= "", status = "", notification_type = "", page = 1) => {
  let queryParams = {
    page: page,
    ...(type.length && {schedule_type: type}),
    ...(status.length && {status: status}),
    ...(notification_type && {type: notification_type})
  }
  return apiService.get(URIS.bulk_noitification, {params: queryParams})
}

export const getScheduledNotification = (type= "", status = "", notification_type = "", page = 1) => {
  let queryParams = {
    // page_size:  itemPerPage,
    page: page,
    ...(type.length && {schedule_type: type}),
    ...(status.length && {status: status}),
    ...(notification_type && {type: notification_type})
  }
  return apiService.get(URIS.scheduled_notification, {params: queryParams})
  // return {
  //   data: [
  //     {
  //       created_at: '2023-01-24T02:47:06.580663',
  //       updated_at: null,
  //       message:
  //         'stringttasdf asdf sad fa qweq cas;doicjad casd fasdoifjadjfsald sadf sadf',
  //       id: '3c11516a-833c-4ad7-a524-befd73ccabef',
  //       type: 'APP_NOTIFICATION',
  //       schedule_type: 'RECURRING',
  //       scheduled_at: '2023-01-25T18:11',
  //       expires_at: '2023-01-25T18:11',
  //       title: 'asdfasd asdfasdfasd sadfasdf',
  //       image_url:
  //         'https://jeeveedev.s3.us-east-2.amazonaws.com/development/cms/featured-banner/aced4f60-cabe-47d7-b13a-68a9963888f8.jpeg',
  //       filter: [
  //         {
  //           type: 'age',
  //           from: '19',
  //           to: '19',
  //         },
  //         {
  //           type: 'Wishlist',
  //           from: '19',
  //           to: '19',
  //         },
  //         {
  //           type: 'cart',
  //           from: '2000',
  //           to: '3000',
  //         },
  //         {
  //           type: 'gender',
  //           value: 'Male',
  //         },
  //         {
  //           type: 'wishlist',
  //           products: [{ id: '123' }, { id: '321' }],
  //         },
  //         {
  //           type: 'cart',
  //           products: [{ id: '4550' }, { id: '4511' }],
  //         },
  //       ],
  //       // extras: {
  //       //   notification_group: 'PRODUCTS',
  //       //   sub_group: 'DETAILS',
  //       //   name: 'Basket',
  //       //   id: '4550',
  //       //   link: '/products/basket-4550',
  //       // },

  //       extras: {
  //         notification_group: 'PRODUCTS',
  //         sub_group: 'BRAND',
  //         name: 'Me N Moms',
  //         id: '3',
  //         link: '/products/brands/me-n-moms-3',
  //       },
  //       status: 'SENT',
  //       repeat_method: 'DAILY',
  //     },
  //     {
  //       created_at: '2023-01-24T02:47:06.592020',
  //       updated_at: null,
  //       message: 'stringtt',
  //       id: 'aca1c690-d854-4824-8926-6732519950c1',
  //       type: 'Email',
  //       schedule_type: 'RECURRING',
  //       scheduled_at: '2023-01-25T02:36:08.268000',
  //       title: 'stringtt',
  //       filter: [
  //         {
  //           value: 'MALE',
  //           type: 'gender',
  //         },
  //         {
  //           type: 'wishlist',
  //           products: [{ id: '123' }, { id: '321' }],
  //         },
  //         {
  //           type: 'cart',
  //           products: [{ id: '123' }, { id: '321' }],
  //         },
  //       ],
  //       payload: {
  //         additionalProp1: 'string',
  //         additionalProp2: 'string',
  //         additionalProp3: 'string',
  //       },
  //       status: 'PENDING',
  //       repeat_method: 'DAILY',
  //     },
  //   ],
  // }
}


const URIS_D = (url, param1) => {
  return {
    scheduled: `/v1/notifications/scheduled-notification/${param1}`
  }[url]
}

const URIS = {
  scheduled_notification: '/v1/notifications/scheduled-notifications',
  notification: '/v1/notifications/broadcast-notifications',
  user_notification: '/v1/notifications/user-notifications',
  products: '/v1/products',
  mobile_notification: '/v1/notifications/user-notifications',
  receiver_count: '/v1/notifications/receivers',
  notification_report: '/v1/notifications/notification-report',
  bulk_noitification: '/v1/notifications'
}
